import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import Sidebar from "../../../partials/aside/Sidebar";
import httpService from "../../../../services/httpServices/httpServices";
import helpersNumber from "../../../../helpers/numbers";
import linkTypeCampaigns from "./../linkTypeCampaigns";
import helperSpinner from "../../../../helpers/spinner";
import StatusCampaignSimple from "./banner/StatusCampaignSimple";
import TitleBar from "../../../partials/content/TitleBar";
import Pagination from "../../../partials/content/Pagination";

function AllCampaigns({ userID }) {
  const [tokenCustomer, setTokenCustomer] = useState();
  const [campaigns, setCampaigns] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [countItemPerPage, setCountItemPerPage] = useState(10);
  const [countPage, setCountPage] = useState(1);
  const [nameCampaignSearchFilter, setNameCampaignSearchFilter] = useState();

  useEffect(() => {
    getTokenCustomer();
  }, [tokenCustomer]);

  useEffect(() => {
    setTokenCustomer();
  }, [userID]);

  useEffect(() => {
    if (!tokenCustomer) {
      return;
    }

    getCampaignsUser();
  }, [currentPage, countItemPerPage, nameCampaignSearchFilter, tokenCustomer]);

  const getTokenCustomer = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestGetTokenUser = await sendRequestGetTokenUser(userID);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!resultSendRequestGetTokenUser) {
      return;
    }

    setTokenCustomer(resultSendRequestGetTokenUser);
  };

  const getHeaderRequestForCustomer = () => {
    const headersRequest = {
      headers: {
        authorization: `Bearer ${tokenCustomer}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const sendRequestGetTokenUser = async (userID) => {
    let token;
    let headersRequest = getHeaderRequest();
    try {
      token = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/user/enter-users-profile-customer-coworker/" +
          userID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return token.data.data;
  };

  const getHeaderRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const sendRequestGetCampaignsUser = async (searchFilterQuery) => {
    const headersRequest = getHeaderRequestForCustomer();
    let campaignsUser;
    try {
      campaignsUser = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/campaign?page=${currentPage}&number=${countItemPerPage}${searchFilterQuery}`,
        headersRequest
      );
      helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return campaignsUser.data.data;
  };

  const getCampaignsUser = async () => {
    const searchFilterQuery = getSearchFilterQuery();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const campaigns = await sendRequestGetCampaignsUser(searchFilterQuery);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!campaigns) {
      return;
    }
    setCampaigns(campaigns.campaigns);
    setCountPage(campaigns.count_page);
  };

  const getSearchFilterQuery = () => {
    let searchFilterQuery = "";
    if (nameCampaignSearchFilter) {
      searchFilterQuery = `${searchFilterQuery}&name=${nameCampaignSearchFilter}`;
    }

    return searchFilterQuery;
  };

  const paginationItemOnClickHandler = async (e) => {
    if (!e.target.attributes[1]) {
      return;
    }

    setCurrentPage(e.target.attributes[1].value);
  };

  const generatePagination = () => {
    return (
      <div className="py-2 d-flex flex-column flex-md-row  align-items-md-center  ">
        <Pagination
          countPage={countPage}
          currentPage={currentPage}
          paginationItemOnClickHandler={paginationItemOnClickHandler}
        />
      </div>
    );
  };

  const getUrlTypeCampaigns = (campaignType) => {
    return linkTypeCampaigns.typeCampaignUrl()[campaignType];
  };

  const generateCampaignsUserTag = () => {
    const campaignRowsTag = campaigns.map((campaign, index) => {
      let textStateCampaign =
        StatusCampaignSimple.statusCampaignString()[campaign.status];

      let tagClass;
      switch (campaign.status) {
        case StatusCampaignSimple.statusCampaign.PENDING_TO_START_DATE:
          tagClass = "warning";
          break;
        case StatusCampaignSimple.statusCampaign.ACTIVE:
          tagClass = "success";
          break;
        case StatusCampaignSimple.statusCampaign.FINISHED:
          tagClass = "info";
          break;
        case StatusCampaignSimple.statusCampaign.CANCELED:
          tagClass = "danger";
          break;
      }
      const urlCampaign = getUrlTypeCampaigns(campaign.type);

      return (
        <tr key={index}>
          <td>{helpersNumber.toPersianNum(index + 1)}</td>
          <td>{helpersNumber.toPersianNum(campaign.id)}</td>
          <td>{campaign.name}</td>
          <td>{campaign.category}</td>
          <td>{campaign.type}</td>
          <td dir="ltr">{helpersNumber.toPersianNum(campaign.created_at)}</td>
          <td dir="ltr">{helpersNumber.toPersianNum(campaign.start_date)}</td>
          <td dir="ltr">{helpersNumber.toPersianNum(campaign.end_date)}</td>
          <td>
            <div className="text-center">
              <span className={`badge badge-${tagClass} `}>
                {textStateCampaign}
              </span>
            </div>
          </td>
          <td>
            <div>
              <span className="pl-2">
                <Link
                  className="btn btn-info  "
                  to={
                    "/campaigns/coworker/banner/simple/view/" +
                    userID +
                    "/" +
                    campaign.id
                  }
                >
                  <i className="fa fa-info"></i>
                </Link>
              </span>
            </div>
          </td>
        </tr>
      );
    });

    return (
      <>
        <div className="py-2">
          <Link
            to={`/campaigns/coworker/all-type/${userID}`}
            className="btn btn-success"
          >
            <span className="py-2">
              <i className="fa fa-plus"></i>
            </span>
            <span>اضافه کردن کمپین</span>
          </Link>
        </div>

        <div class="container-fluid ">
          <div class="row border border-1 rounded py-2">
            <div class="col-12 col-md-4">
              <div>
                <label>جستجو در نام کمپین</label>
              </div>
              <div>
                <input
                  className="form-control"
                  type="text"
                  placeholder="نام کمپین را در اینجا وارد کنید "
                  onKeyUp={(e) => setNameCampaignSearchFilter(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="table-responsive pt-2">
          <table className="table table-hilite tbl-td-white-space  m-0">
            <thead>
              <tr>
                <td>#</td>
                <td>شماره کمپین</td>
                <td>نام کمپین</td>
                <td>نام گروه نمایش دهنده</td>
                <td>نوع کمپین</td>
                <td>تاریخ ایجاد</td>
                <td>تاریخ شروع</td>
                <td>تاریخ پایان</td>
                <td>وضعیت</td>
                <td>عملیات</td>
              </tr>
            </thead>
            <tbody>{campaignRowsTag}</tbody>
          </table>
        </div>
        {countPage > 1 ? generatePagination() : <></>}
      </>
    );
  };

  const generateDoNotHaveCampaignsUserTag = () => {
    return (
      <>
        <div className="d-flex flex-column flex-md-row">
          <div className="text-center text-md-right">
            <img
              class="img-fluid"
              src="/assets/img/do-not-have-campaigns.svg"
            />
          </div>
          <div className="d-flex flex-column justify-content-center pr-0 pt-3  pr-md-3 pt-md-0">
            <p className="text-justify">
              {" "}
              کاربر در حال حاضر هیچ کمپینی ندارد :(
            </p>
            <p className="text-justify">برای شروع کار یک کمپین بسازید.</p>
            <p className="text-justify">
              کمپین تبلیغاتی به کاربرکمک می کند تا پیام مناسب در دوره زمانی
              مناسب با بودجه دلخواه برای مخاطب مناسب ارسال شود.
            </p>
            <div>
              <Link
                to={`/campaigns/coworker/all-type/${userID}`}
                className="btn btn-success"
              >
                <span className="pl-2">
                  <i className="fa fa-plus"></i>
                </span>
                <span>اضافه کردن کمپین</span>
              </Link>
            </div>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      {campaigns.length == 0 && nameCampaignSearchFilter == null
        ? generateDoNotHaveCampaignsUserTag()
        : generateCampaignsUserTag()}
    </>
  );
}

export default AllCampaigns;
